import React from 'react';
import HoverActionButtons from '../buttons/HoverActionButtons';
import EditableListDescription from './EditableListDescription';
import LinkListDescription from './LinkListDescription';
import MarkdownListDescription from './MarkdownListDescription';

const HoverListDescription = ({
  canEdit,
  className,
  disabled,
  editCopyMods = 'list-description',
  linkTarget,
  markdown,
  position,
  showEdit,
  toolTip,
  value,
}) => (
  <HoverActionButtons
    canEdit={canEdit}
    showEdit={showEdit}
    value={value}
    disabled={disabled}
    editCopyMods={editCopyMods}
    position={position}
    toolTip={toolTip}
  >
    {!canEdit && markdown && (<MarkdownListDescription value={value} className={className} linkTarget={linkTarget} />)}
    {!canEdit && !markdown && (<LinkListDescription value={value} className={className} />)}
    {canEdit && (
    <EditableListDescription
      content={value}
      markdown={markdown}
      className={className}
      linkTarget={linkTarget}
    />
    )}
  </HoverActionButtons>
);

export default HoverListDescription;
